module.exports = __webpack_public_path__ + "img/reportAvatar2.a64692b5.png";